<template>
  <layout>
    <div
      class="container mt-4 mb-4 d-flex justify-content-between align-items-center"
    >
      <div>
        <h3 v-if="accessValue && user" style="font-weight:bold;">
          {{
            $t("dashboard.welcome", {
              name: userName
            })
          }}
        </h3>
        <h6>{{ $t("dashboard.welcomeMsg") }}</h6>
      </div>
      <div>
        <b-button
          v-if="activateAddPaymentMethodBtn"
          to="/billing/addPaymentMethod"
          variant="primary"
          style="font-size: 14px; padding: 10px 30px;"
        >
          ADD PAYMENT METHOD
        </b-button>
        <b-button
          v-if="practiceSuitePaymentLink"
          @click="goToPayment"
          variant="primary"
          style="font-size: 14px; padding: 10px 30px;"
        >
          MAKE A PAYMENT
        </b-button>
      </div>
    </div>

    <div class="container mb-4">
      <div class="row">
        <home-pending-documents />

        <home-appointments />
      </div>
    </div>
  </layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Layout from "../workspace/Layout.vue";
import HomeAppointments from "./HomeAppointments.vue";
import HomePendingDocuments from "./HomePendingDocuments.vue";
import paymentMethodsServer from "../../server/paymentMethod";
import accessServer from "../../server/accesses";

export default {
  name: "Home",
  components: {
    Layout,
    HomeAppointments,
    HomePendingDocuments
  },
  data() {
    return {
      activateAddPaymentMethodBtn: false,
      accessValue: null
    };
  },
  async mounted() {
    this.accessValue = await accessServer.queryById(this.user.Id);
    this.activateAddPaymentButton();
  },
  methods: {
    goToPayment() {
      window.open(this.practiceSuitePaymentLink, "_blank");
    },
    async activateAddPaymentButton() {
      const paymenteMethods = await this.getAllPaymentMethods();
      this.activateAddPaymentMethodBtn =
        Array.isArray(paymenteMethods) && paymenteMethods.length === 0;
    },
    async getAllPaymentMethods() {
      const response = await paymentMethodsServer.query(this.user.Patient.Id);
      return response.data;
    }
  },
  computed: {
    ...mapGetters("session", ["user"]),
    ...mapState("session", {
      practiceSuitePaymentLink: state =>
        state.systemSettings.practiceSuitePaymentLink
    }),
    userName() {
      if (this.accessValue?.data?.relationship != "Patient") {
        return this.user.Name;
      } else {
        return this.user.Patient.PreferredName?.length
          ? this.user.Patient.PreferredName.concat(
              " ",
              this.user.Patient.LastName
            )
          : this.user.Patient.FirstName.concat(" ", this.user.Patient.LastName);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
